import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as yup from "yup";
import Form from "react-formal";
import { Helmet } from "react-helmet";
const baseURL = process.env.REACT_APP_API_URL;

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email")
    .required("Required"),
});

export default class ForgotPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      forgotPassword: {
        email: "",
      },
      submitting: false,
      success: false,
      error: false,
      message: "",
    };
    this.submit = this.submit.bind(this);
  }

  async submit(values) {
    this.setState({ submitting: true });

    let result = await axios.post(`${baseURL}/users/forgotPassword`, values);
    if (result.data.message) {
      this.setState({
        submitting: false,
        success: result.data.success,
        message: result.data.message,
      });
    } else {
      this.setState({
        submitting: false,
        success: false,
        message: "Looks like something went wrong. Please try again.",
      });
    }
  }

  render() {
    return (
      <div className="page-account page-login">
        <Helmet>
          <title>Forgot Password | Zivug Zone</title>
        </Helmet>
        <div className="page-account-container">
          <Link to={"/login"}>
            <img
              src="/images/login-logo.png"
              alt=""
              className="page-account-logo"
            />
          </Link>

          <Form
            id="form"
            className="page-account-content mui--z1"
            schema={schema}
            value={this.state.forgotPassword}
            onChange={model => this.setState({ forgotPassword: model })}
            onSubmit={this.submit}
          >
            <h3>Reset password</h3>
            <div>
              <legend>
                Enter Your Email
                <Form.Message className="has-error" for="email" />
              </legend>
              <Form.Field
                placeholder="ralph@zivugtech.org"
                name="email"
                className="form-input-margin-bottom"
              />
              {this.state.submitting ? (
                <p className="btn-flat btn-primaryAccent text-align-center btn-loader">
                  <span className="loader-small"></span>
                </p>
              ) : (
                <button
                  type="submit"
                  className="btn-flat btn-primaryAccent btn-loader text-align-center"
                >
                  {this.state.success
                    ? "Resend Password Reset Link"
                    : "Request Password Reset Link"}
                </button>
              )}
            </div>
            <p className="form-message-bottom text-align-center">
              {this.state.message}
            </p>
          </Form>

          <p className="page-account-text-link page-account-text-link-light text-align-center">
            <Link to={`login`}>Back to login</Link>
          </p>

          {/* <div className="powered-by">
            <a
              href={"https://bitbean.com"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>
                Built with <FontAwesome name="heart" /> by{" "}
              </span>{" "}
              bitbean.com
            </a>
          </div> */}
        </div>
      </div>
    );
  }
}
